import axios from "axios";
import { SEA_TURTLE_WEB_API } from "@/constants/appConstant";

const getAuthHeaders = () => {
    const token = localStorage.getItem("token");
    return {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + token
    };
};

export async function getPostsByTopicUrlName(urlName, currentPage) {
    try {
        const url = `${SEA_TURTLE_WEB_API}/posts/topicUrl?urlName=${urlName}&pageNumber=${currentPage}`;
        
        const response = await fetch(url, {
            method: "GET",
            headers: { 
                "Content-Type": "application/json" 
            },
            // CẤU HÌNH CACHE BÊN DƯỚI (Chọn 1 trong 3 tùy vào mục đích SEO/Performance):
            
            // 1. Dùng cho SSR (Luôn fetch dữ liệu mới nhất mỗi khi load trang)
            // cache: 'no-store', 
            
            // 2. Dùng cho SSG (Lưu cache vĩnh viễn lúc build, nhanh nhất nhưng không tự cập nhật bài mới)
            // cache: 'force-cache', 
            
            // 3. Dùng cho ISR (Cache dữ liệu và tự động cập nhật ngầm sau mỗi 60 giây - Khuyên dùng)
            next: { revalidate: 60 }, 
        });

        // Khác với axios, fetch sẽ không tự nhảy vào block 'catch' khi gặp lỗi HTTP (ví dụ: 404, 500)
        // Do đó ta cần tự kiểm tra response.ok
        if (!response.ok) {
            console.error(`Lỗi HTTP! Trạng thái: ${response.status}`);
            return { data: null, error: true };
        }

        // Chuyển đổi response sang JSON
        const data = await response.json();
        
        // Trả về object có bọc key 'data' để tương thích với cấu trúc cũ đang dùng: response?.data.data.content
        return { data: data }; 

    } catch (error) {
        console.error("Lỗi khi fetch getPostsByTopicUrlName trên Server:", error);
        return { data: null, error: error.message };
    }
}

export const getAllPost = async () => {
    let result = null;
    try {
        result = await axios({
            method: "get",
            url: `${SEA_TURTLE_WEB_API}/posts`,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
    } catch (e) {
        console.error(e);
    }
    return result;
};

export const getPostDataByUrl = async (url) => {
    let result = null;
    try {
        result = await axios({
            method: "get",
            url: `${SEA_TURTLE_WEB_API}/posts/url?value=${url}`,
            headers: { "Content-Type": "application/json" },
        });
    } catch (e) {
        console.error("Lỗi getPostDataByUrl:", e);
    }
    return result?.data.data;
}

export const addPostIntroduce = async (data) => {
    let result = null;
    try {
        result = await axios({
            method: "put",
            url: `${SEA_TURTLE_WEB_API}/posts/introduce`,
            headers: { "Content-Type": "application/json" },
            data: data,
        });
    } catch (e) {
        console.error(e);
    }
    return result?.data.data;
}

export const addPostContact = async (data) => {
    let result = null;
    try {
        result = await axios({
            method: "post",
            url: `${SEA_TURTLE_WEB_API}/posts/contact`,
            headers: { "Content-Type": "application/json" },
            data: data,
        });
    } catch (e) {
        console.error(e);
    }
    return result?.data.data;
}

export const getPostContact = async () => {
    let result = null;
    try {
        result = await axios({
            method: "get",
            url: `${SEA_TURTLE_WEB_API}/posts/contact`,
            headers: { "Content-Type": "application/json" },
        });
    } catch (e) {
        console.error(e);
    }
    return result?.data.data;
}

export const getPostIntroduce = async () => {
    let result = null;
    try {
        result = await axios({
            method: "get",
            url: `${SEA_TURTLE_WEB_API}/posts/introduce`,
            headers: { "Content-Type": "application/json" },
        });
    } catch (e) {
        console.error(e);
    }
    return result?.data.data;
}

export async function getFiveNewestPosts(id) {
    let response = null;
    await axios({
        url: `${SEA_TURTLE_WEB_API}/posts/newest-post-detail-page/${id}`,
        headers: { "Content-Type": "application/json" },
        method: "GET",
    })
        .then((res) => {
            response = res;
        })
        .catch((e) => {
            response = e.response;
        });
    return response?.data.data;
}

export const checkUrlExist = async (url, id) => {
    let result = null;
    id = id === null ? "" : id;
    try {
        result = await axios({
            method: "get",
            url: `${SEA_TURTLE_WEB_API}/posts/url-exist?value=${url}&id=${id}`,
            headers: { "Content-Type": "application/json" },
        });
    } catch (e) {
        console.error(e);
    }
    return result?.data.data;
}

export const getFivePostByKeyword = async (keyword) => {
    let response = null;
    await axios({
        url: `${SEA_TURTLE_WEB_API}/posts/relate-post?keyword=${keyword}`,
        headers: { "Content-Type": "application/json" },
        method: "GET"
    })
        .then((res) => {
            response = res;
        })
        .catch((e) => {
            response = e.response;
        });
    return response;
}

export const getOldProjectsInPostDetail = async () => {
    let response = null;
    await axios({
        url: `${SEA_TURTLE_WEB_API}/posts/random-post`,
        headers: { "Content-Type": "application/json" },
        method: "GET"
    })
        .then((res) => {
            response = res;
        })
        .catch((e) => {
            response = e.response;
        });
    return response;
}

export const getPostByUrlNameToSeverSide = async (url) => {
    let result = null;
    try {
        result = await axios({
            method: "get",
            url: `${SEA_TURTLE_WEB_API}/posts/sever/url?value=${url}`,
            headers: { "Content-Type": "application/json" },
        });
    } catch (e) {
        console.error(e);
    }
    return result?.data.data;
}

export const getAllPostToSeverSide = async () => {
    let result = null;
    try {
        result = await axios({
            method: "get",
            url: `${SEA_TURTLE_WEB_API}/posts/sever`,
            headers: { "Content-Type": "application/json" },
        });
    } catch (e) {
        console.error(e);
    }
    return result?.data.data;
}


export const createPost = async (postData) => {
    let result = null;
    try {
        result = await axios.post(`${SEA_TURTLE_WEB_API}/articles`, postData, {
            headers: getAuthHeaders()
        });
    } catch (e) {
        console.error("Lỗi khi tạo Post:", e.response?.data || e.message);
        return e.response;
    }
    return result;
}

export const updatePost = async (postId, postData) => {
    let result = null;
    try {
        result = await axios.put(
            `${SEA_TURTLE_WEB_API}/articles/${postId}`,
            postData,
            { headers: getAuthHeaders() }
        );
    } catch (e) {
        console.error("Lỗi khi cập nhật Post:", e.response?.data || e.message);
        return e.response;
    }
    return result;
}

export const getPostById = async (id) => {
    let result = null;
    try {
        result = await axios({
            method: "get",
            url: `${SEA_TURTLE_WEB_API}/articles/${id}`,
            headers: getAuthHeaders(),
        });
    } catch (e) {
        console.error("Lỗi getPostById:", e);
    }
    return result?.data.data;
}

export const getPosts = async ({ page, size, keyword }) => {
    let result = null;
    try {
        result = await axios({
            method: "get",
            url: `${SEA_TURTLE_WEB_API}/articles?page=${page}&size=${size}&search=${keyword}`,
            headers: getAuthHeaders(),
        });
    } catch (e) {
        console.error(e);
    }
    return result;
};

export const getPostsByTopicId = async ({ page, size, keyword }) => {
    let result = null;
    try {
        result = await axios({
            method: "get",
            url: `${SEA_TURTLE_WEB_API}/articles/news?page=${page}&size=${size}&search=${keyword}`,
            headers: getAuthHeaders(),
        });
    } catch (e) {
        console.error(e);
    }
    return result;
};

export const deleteArticleList = async (id) => {
    let result = null;
    try {
        result = await axios({
            method: "delete",
            url: `${SEA_TURTLE_WEB_API}/articles`,
            headers: getAuthHeaders(), 
            data: { id: id },
        });
    } catch (e) {
        console.error(e);
    }
    return result;
};

export const deleteArticleById = async (id) => {
    let result = null;
    try {
        result = await axios({
            method: "delete",
            url: `${SEA_TURTLE_WEB_API}/articles/${id}`,
            headers: getAuthHeaders(), 
        });
    } catch (e) {
        console.error(e);
    }
    return result;
};

export const updateArticleStatus = async (id, newStatus) => {
    let result = null;
    try {
        result = await axios({
            method: "put",
            url: `${SEA_TURTLE_WEB_API}/articles/update-article-status/${id}?isHidden=${newStatus}`,
            headers: getAuthHeaders(), 
        });
    } catch (e) {
        console.error(e);
    }
    return result;
};

export const getShippedGoodsSlider = async (limit = 8) => {
    try {
        const response = await fetch(
            `${SEA_TURTLE_WEB_API}/posts/shipped?limit=${limit}`,
            { next: { revalidate: 3600 } }
        );

        if (!response.ok) return [];

        const result = await response.json();
        return result?.data ?? [];
    } catch {
        return [];
    }
}
